const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

const parseHtml = (html) => new DOMParser().parseFromString(html, "text/html");

const updateCartCount = (count) => {
  document.querySelectorAll("[data-cart-count]").forEach((node) => {
    const value = Number(count) || 0;
    node.hidden = value < 1;
  });
};

const refreshCart = async (open) => {
  const response = await fetch(`${root()}?sections=cart-drawer`);
  const data = await response.json();
  const markup = data["cart-drawer"];
  if (!markup) return;
  const next = parseHtml(markup).querySelector("#CartDrawer");
  const current = document.querySelector("#CartDrawer");
  if (!next || !current) return;
  const wasOpen = current.open;
  current.replaceWith(next);
  updateCartCount(next.dataset.count);
  if (open || wasOpen) document.querySelector("#CartDrawer")?.showModal();
};

const addVariants = async (items) => {
  const response = await fetch(`${root()}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items }),
  });
  if (!response.ok) return;
  await refreshCart(true);
};

const variantForSize = (product, size) => {
  const variants = product.variants || [];
  const sized = variants.find((variant) => variant.available && variant.options.includes(size));
  if (sized) return sized;
  return (
    variants.find((variant) => variant.available && variant.options.some((option) => /one size/i.test(option))) ||
    variants.find((variant) => variant.available) ||
    null
  );
};

const money = (cents) => {
  const format = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: format || "USD",
    }).format(cents / 100);
  } catch {
    return `$${(cents / 100).toFixed(0)}`;
  }
};

document.querySelectorAll(".header-shell").forEach((shell) => {
  const shop = shell.querySelector(".nav-item--shop");
  const mega = shell.querySelector(".mega");
  if (!shop || !mega) return;
  const open = () => shell.classList.add("is-mega");
  shop.addEventListener("mouseenter", open);
  shop.addEventListener("focusin", open);
  shell.addEventListener("mouseleave", () => shell.classList.remove("is-mega"));
  shell.addEventListener("focusout", (event) => {
    if (!shell.contains(event.relatedTarget)) shell.classList.remove("is-mega");
  });
});

const headerGroup = document.querySelector(".shopify-section-group-header-group");
const headerBar = headerGroup?.querySelector(".header-bar");
if (headerBar) {
  const setHeaderHeight = () => {
    const announcement = headerGroup.querySelector(".announcement")?.offsetHeight || 0;
    const bar = headerBar.getBoundingClientRect().bottom - headerGroup.getBoundingClientRect().top + 1 - announcement;
    document.documentElement.style.setProperty("--announcement-height", `${announcement}px`);
    document.documentElement.style.setProperty("--header-height", `${Math.round(bar)}px`);
  };
  new ResizeObserver(setHeaderHeight).observe(headerGroup);
}

document.addEventListener("click", async (event) => {
  const cartOpen = event.target.closest("[data-cart-open]");
  if (cartOpen) {
    event.preventDefault();
    document.querySelector("#CartDrawer")?.showModal();
    return;
  }

  const cartClose = event.target.closest("[data-cart-close]");
  if (cartClose) {
    event.preventDefault();
    document.querySelector("#CartDrawer")?.close();
    return;
  }

  const add = event.target.closest("[data-add-variant]");
  if (add && !add.disabled) {
    event.preventDefault();
    await addVariants([{ id: Number(add.dataset.addVariant), quantity: 1 }]);
    return;
  }

  const qty = event.target.closest("[data-qty]");
  if (qty) {
    event.preventDefault();
    const line = qty.closest("[data-line-key]");
    const current = Number(line?.dataset.qty || 1);
    const next = qty.dataset.qty === "increase" ? current + 1 : qty.dataset.qty === "remove" ? 0 : Math.max(0, current - 1);
    await fetch(`${root()}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: line.dataset.lineKey, quantity: next }),
    });
    await refreshCart(true);
    return;
  }

  const pageQty = event.target.closest("[data-page-qty]");
  if (pageQty) {
    event.preventDefault();
    const field = pageQty.closest(".qty")?.querySelector("input");
    if (field) {
      const delta = pageQty.dataset.pageQty === "increase" ? 1 : -1;
      field.value = Math.max(0, Number(field.value || 0) + delta);
      field.closest("form")?.querySelector("[name='update']")?.click();
    }
    return;
  }

  const filterOpen = event.target.closest("[data-filters-open]");
  if (filterOpen) {
    document.querySelector("#FilterDrawer")?.showModal();
    return;
  }

  const filterClose = event.target.closest("[data-filters-close]");
  if (filterClose) {
    document.querySelector("#FilterDrawer")?.close();
    return;
  }

  const searchToggle = event.target.closest("[data-search-toggle]");
  if (searchToggle) {
    const panel = document.querySelector("[data-search-panel]");
    const open = panel?.classList.toggle("is-open");
    searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) panel.querySelector("input")?.focus();
    return;
  }

  const menuToggle = event.target.closest("[data-menu-open]");
  if (menuToggle) {
    document.querySelector("#MobileNav")?.showModal();
    return;
  }

  const menuClose = event.target.closest("[data-menu-close]");
  if (menuClose) {
    document.querySelector("#MobileNav")?.close();
    return;
  }

  const filterToggle = event.target.closest("[data-filter-toggle]");
  if (filterToggle) {
    const key = filterToggle.dataset.filterToggle;
    document.querySelectorAll("[data-filter-panel]").forEach((panel) => {
      panel.classList.toggle("is-open", panel.dataset.filterPanel === key && !panel.classList.contains("is-open"));
    });
    return;
  }

  const chartOpen = event.target.closest("[data-size-chart-open]");
  if (chartOpen) {
    event.preventDefault();
    document.querySelector("#SizeChart")?.showModal();
    return;
  }

  const chartClose = event.target.closest("[data-size-chart-close]");
  if (chartClose) {
    document.querySelector("#SizeChart")?.close();
    return;
  }

  const share = event.target.closest("[data-share]");
  if (share) {
    event.preventDefault();
    const url = share.dataset.url;
    const title = share.dataset.title;
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
      return;
    }
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      const original = share.textContent;
      share.textContent = share.dataset.copied || original;
      window.setTimeout(() => {
        share.textContent = original;
      }, 1600);
    }
  }
});

document.addEventListener("click", (event) => {
  const dialog = event.target.closest("dialog");
  if (event.target === dialog) dialog.close();
});

document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-product] form");
  if (!form) return;
  event.preventDefault();
  const id = form.querySelector("[name='id']")?.value;
  const note = form.querySelector("[data-size-required]");
  if (!id) {
    if (note) {
      const missing = [...new Set([...form.querySelectorAll("[data-option-index]")].map((b) => b.dataset.optionIndex))]
        .filter((index) => !form.querySelector(`[data-option-index="${index}"].is-on`))
        .map((index) => form.querySelector(`[data-option-index="${index}"]`).dataset.optionName.toLowerCase());
      if (note.dataset.message && missing.length) note.textContent = note.dataset.message.replace("__OPTION__", missing.join(" and "));
      note.hidden = false;
    }
    return;
  }
  if (note) note.hidden = true;
  await addVariants([{ id: Number(id), quantity: 1 }]);
});

const searchInput = document.querySelector("[data-search-input]");
let searchTimer;
searchInput?.addEventListener("input", () => {
  window.clearTimeout(searchTimer);
  searchTimer = window.setTimeout(async () => {
    const query = searchInput.value.trim();
    const results = document.querySelector("[data-search-results]");
    if (!results) return;
    if (!query) {
      results.innerHTML = "";
      return;
    }
    const url = `${root()}search/suggest?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[type]=product,article,page&resources[limit]=6&resources[limit_scope]=each`;
    const response = await fetch(url, { headers: { Accept: "text/html" } });
    const html = await response.text();
    const next = parseHtml(html).querySelector("[data-search-results]");
    results.innerHTML = next ? next.innerHTML : "";
  }, 200);
});

document.querySelectorAll("[data-product]").forEach((rootNode) => {
  const data = JSON.parse(rootNode.querySelector("[data-product-json]")?.textContent || "{}");
  const variants = data.variants || [];
  const input = rootNode.querySelector("[name='id']");
  const price = rootNode.querySelector("[data-product-price]");
  const add = rootNode.querySelector("[data-product-add]");
  const selected = {};
  rootNode.querySelectorAll("[data-option-index].is-on").forEach((button) => {
    selected[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
  });

  const match = () =>
    variants.find((variant) =>
      variant.options.every((option, index) => !selected[index] || selected[index] === option)
    );

  rootNode.querySelectorAll("[data-option-index]").forEach((button) => {
    button.addEventListener("click", () => {
      const index = Number(button.dataset.optionIndex);
      selected[index] = button.dataset.optionValue;
      const current = rootNode.querySelector(`[data-option-current="${index}"]`);
      if (current) current.textContent = button.dataset.optionValue;
      rootNode.querySelectorAll(`[data-option-index="${index}"]`).forEach((peer) => {
        peer.classList.toggle("is-on", peer === button);
        peer.setAttribute("aria-pressed", peer === button ? "true" : "false");
      });
      const variant = variants.find((item) => item.options.every((option, optionIndex) => selected[optionIndex] === option));
      const note = rootNode.querySelector("[data-size-required]");
      if (note) note.hidden = true;
      if (!variant || !input) return;
      input.value = variant.id;
      if (price) price.textContent = money(variant.price);
      rootNode.querySelectorAll("[data-product-price-mirror]").forEach((node) => { node.textContent = money(variant.price); });
      const notify = rootNode.querySelector("[data-notify-me]");
      if (notify) {
        notify.hidden = variant.available;
        const link = notify.querySelector("[data-notify-link]");
        if (link && !variant.available) {
          const title = rootNode.querySelector("h1")?.textContent.trim() || "";
          link.href = `mailto:${link.dataset.email || link.getAttribute("href").split("?")[0].replace("mailto:", "")}?subject=${encodeURIComponent(`Notify me: ${title} (${variant.options.join(" / ")})`)}`;
        }
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      } catch (error) { /* url update is a nicety only */ }
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? add.dataset.labelAdd : add.dataset.labelSold;
      }
      rootNode.querySelectorAll("[data-gallery-slide]").forEach((slide, slideIndex) => {
        if (variant.featured_media && slide.dataset.mediaId === String(variant.featured_media.id)) {
          rootNode.querySelectorAll("[data-gallery-slide]").forEach((item) => item.hidden = item !== slide);
          rootNode.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
            thumb.classList.toggle("is-on", thumb.dataset.mediaId === String(variant.featured_media.id));
          });
        }
        return slideIndex;
      });
    });
  });

  rootNode.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const id = thumb.dataset.mediaId;
      rootNode.querySelectorAll("[data-gallery-slide]").forEach((slide) => {
        slide.hidden = slide.dataset.mediaId !== id;
      });
      rootNode.querySelectorAll("[data-gallery-thumb]").forEach((item) => item.classList.toggle("is-on", item === thumb));
    });
  });

  const stickyAdd = rootNode.querySelector("[data-pdp-sticky-add]");
  const sticky = rootNode.querySelector("[data-pdp-sticky]");
  if (stickyAdd && add) {
    stickyAdd.addEventListener("click", () => {
      if (add.disabled) {
        add.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      add.click();
    });
    if (sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle("is-on", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(add);
    }
    const syncSticky = () => { stickyAdd.textContent = add.textContent.trim(); stickyAdd.disabled = false; stickyAdd.classList.toggle("is-sold-out", add.disabled); };
    new MutationObserver(syncSticky).observe(add, { childList: true, characterData: true, subtree: true });
  }

  /* colour starts selected (label and ring agree); size stays empty until picked */
  if (input && !input.value) {
    const start = variants.find((item) => item.options.every((option, index) => selected[index] === option));
    if (start) input.value = start.id;
  }
});

function formatMeasure(value, kind, unit) {
  if (unit === "cm") return String(value);
  if (kind === "kg") return String(Math.round(value * 2.20462));
  if (kind === "height") {
    const total = Math.round(value / 2.54);
    return `${Math.floor(total / 12)}'${total % 12}"`;
  }
  return String(Math.round(value / 2.54 / 0.25) * 0.25);
}

function applyUnit(chart, unit) {
  chart.querySelectorAll("[data-unit-toggle]").forEach((item) => {
    const on = item.dataset.unitToggle === unit;
    item.classList.toggle("is-on", on);
    item.setAttribute("aria-pressed", on ? "true" : "false");
  });
  chart.querySelectorAll("[data-unit-label]").forEach((label) => {
    const kind = label.dataset.unitLabel;
    if (kind === "kg") label.textContent = unit === "in" ? "lb" : "kg";
    else if (kind === "height") label.textContent = unit === "in" ? "ft" : "cm";
    else label.textContent = unit;
  });
  chart.querySelectorAll("[data-measure]").forEach((cell) => {
    const kind = cell.dataset.kind;
    const min = Number(cell.dataset.min);
    const max = cell.dataset.max ? Number(cell.dataset.max) : null;
    if (unit === "cm") {
      cell.textContent = cell.dataset.original;
      return;
    }
    cell.textContent = max == null ? formatMeasure(min, kind, unit) : `${formatMeasure(min, kind, unit)}–${formatMeasure(max, kind, unit)}`;
  });
}

document.querySelectorAll("[data-unit-toggle]").forEach((button) => {
  button.addEventListener("click", () => {
    const chart = button.closest("[data-size-chart]") || document;
    applyUnit(chart, button.dataset.unitToggle);
  });
});

document.querySelectorAll("[data-size-chart][data-default-unit]").forEach((chart) => {
  applyUnit(chart, chart.dataset.defaultUnit);
});

document.querySelectorAll("[data-size-tabs]").forEach((tabs) => {
  tabs.querySelectorAll("[data-size-tab]").forEach((tab) => {
    tab.addEventListener("click", () => {
      const name = tab.dataset.sizeTab;
      tabs.querySelectorAll("[data-size-tab]").forEach((item) => item.classList.toggle("is-on", item === tab));
      document.querySelectorAll("[data-size-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.sizePanel !== name;
      });
    });
  });
});

const brief = document.querySelector("#CustomBrief");
brief?.addEventListener("submit", () => {
  const body = brief.querySelector("[name='contact[body]']");
  if (!body || body.dataset.composed === "true") return;
  const value = (name) => brief.querySelector(`[name='${name}']`)?.value?.trim() || "";
  const lines = [
    `Team: ${value("contact[team]")}`,
    `Need: ${value("contact[need]")}`,
    `Riders: ${value("contact[riders]")}`,
    `Deadline: ${value("contact[deadline]")}`,
  ];
  const note = body.value.trim();
  body.value = note ? `${lines.join("\n")}\n\n${note}` : lines.join("\n");
  body.dataset.composed = "true";
});

document.querySelectorAll("[data-choice]").forEach((button) => {
  button.addEventListener("click", () => {
    button.classList.toggle("is-on");
    button.setAttribute("aria-pressed", button.classList.contains("is-on") ? "true" : "false");
    const group = button.closest("[data-choice-group]");
    const input = group?.querySelector("input[type='hidden']");
    if (!input) return;
    const values = [...group.querySelectorAll("[data-choice].is-on")].map((item) => item.dataset.choice);
    input.value = values.join(", ");
  });
});

const landing = document.querySelector("[data-landing]");
if (landing) {
  const products = JSON.parse(landing.querySelector("[data-landing-products]")?.textContent || "{}");
  const tiers = {
    jersey: ["jersey"],
    full: ["jersey", "bibs", "hat"],
  };
  let tier = landing.dataset.defaultTier || "full";
  if (!tiers[tier]) tier = "full";
  let size = "";

  const priceFor = (id) => {
    const keys = tiers[id] || [];
    return keys.reduce((sum, key) => {
      const product = products[key];
      if (!product) return sum;
      const variant = size ? variantForSize(product, size) : product.variants?.[0];
      return sum + (variant ? variant.price : 0);
    }, 0);
  };

  const paint = () => {
    landing.querySelectorAll("[data-tier]").forEach((button) => {
      const on = button.dataset.tier === tier;
      button.classList.toggle("is-on", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
      const price = button.querySelector("[data-tier-price]");
      if (price) price.textContent = money(priceFor(button.dataset.tier));
    });
    const sticky = landing.querySelector("[data-landing-price]");
    if (sticky) sticky.textContent = money(priceFor(tier));
    const heading = landing.querySelector("[data-landing-heading]");
    const active = landing.querySelector(`[data-tier="${tier}"]`);
    if (heading && active?.dataset.heading) heading.textContent = active.dataset.heading;
    const image = landing.querySelector("[data-landing-frame] img");
    const shot = products.images?.[tier];
    if (image && shot?.src) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = shot.src;
      image.alt = shot.alt || "";
    }
  };

  landing.querySelectorAll("[data-tier]").forEach((button) => {
    button.addEventListener("click", () => {
      tier = button.dataset.tier;
      paint();
    });
  });

  landing.querySelectorAll("[data-landing-size]").forEach((button) => {
    button.addEventListener("click", () => {
      size = button.dataset.landingSize;
      landing.querySelectorAll("[data-landing-size]").forEach((item) => {
        item.classList.toggle("is-on", item === button);
        item.setAttribute("aria-pressed", item === button ? "true" : "false");
      });
      const note = landing.querySelector("[data-size-required]");
      if (note) note.hidden = true;
      paint();
    });
  });

  const submitLanding = async () => {
    if (!size) {
      const note = landing.querySelector("[data-size-required]");
      if (note) note.hidden = false;
      return;
    }
    const items = (tiers[tier] || [])
      .map((key) => variantForSize(products[key], size))
      .filter(Boolean)
      .map((variant) => ({ id: variant.id, quantity: 1 }));
    if (!items.length) return;
    await addVariants(items);
  };

  landing.querySelectorAll("[data-landing-add]").forEach((button) => {
    button.addEventListener("click", submitLanding);
  });

  paint();
}

const enlargeForms = () => {
  document.querySelectorAll("shopify-forms-embed").forEach((embed) => {
    const root = embed.shadowRoot;
    if (!root || root.getElementById("enjoy-form-size")) return;
    const style = document.createElement("style");
    style.id = "enjoy-form-size";
    style.textContent = `
      @media screen and (max-width: 999px) {
        :host {
          --container-max-w: min(520px, calc(100vw - 32px));
          --forms-heading-font-size: 28px;
          --heading-font-size: 28px;
          --forms-base-font-size: 16px;
        }
        .withImage [data-sizing="form-wrapper"] {
          width: min(560px, calc(100vw - 32px));
          max-width: min(560px, calc(100vw - 32px)) !important;
        }
        h2[class*="textHeading"] {
          font-size: 28px !important;
          line-height: 1.15;
        }
        [class*="copyToClipboardText"] {
          font-size: 28px !important;
        }
      }
      @media screen and (min-width: 1000px) {
        .withImage [data-sizing="form-wrapper"] {
          --col-size: min(480px, calc((100vw - 96px) / 2));
        }
        :host {
          --container-max-w: 560px;
          --forms-heading-font-size: 34px;
          --heading-font-size: 34px;
          --forms-base-font-size: 17px;
        }
        h2[class*="textHeading"] {
          font-size: 34px !important;
          line-height: 1.15;
        }
        [class*="copyToClipboardText"] {
          font-size: 32px !important;
        }
      }
    `;
    root.appendChild(style);
  });
};

enlargeForms();
const formsObserver = new MutationObserver(enlargeForms);
formsObserver.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(() => formsObserver.disconnect(), 20000);
